<template>
  <div class="map-details-btn">
    <router-link to="/Map/1" class="display-1 font-weight-bold">
      <v-btn> Map Details</v-btn></router-link
    >
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.map-details-btn {
  margin: 10px auto;
  width: 100vw;
  display: flex;
  justify-content: center;
}
</style>